export default "__VITE_ASSET__Cxpdr8Q0__"